import { jsx as _jsx } from "react/jsx-runtime";
import { SpeakerView } from '../components/multi-broadcaster/SpeakerView';
/**
 * TODO: Introduce the MobileSpeakerView later
 *  */
export function MultiBroadcasterPage() {
    return _jsx(SpeakerView, {});
}
